// ----------------------------------------------------------------------

const account = {
  displayName: 'Qudus Tosin Aileru',
  email: 'qudus@gmail.com',
  photoURL: '/assets/images/profile.png',
};

export default account;
